module.exports = __webpack_public_path__ + "img/scorecard-standard.cdd0906d.png";